import { render, staticRenderFns } from "./Domain-data.vue?vue&type=template&id=7382f4e5"
import script from "./Domain-data.vue?vue&type=script&lang=js"
export * from "./Domain-data.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports